const PARTNERS = [
    "Hypermarket Chains",
    "Apparel & Fashion",
    "Grocery & Convenience",
    "Electronics Retailers",
    "Home & Furniture",
    "Beauty & Personal Care",
    "Food & Beverage Groups",
    "CPG Brands",
    "Loyalty Networks",
    "POS Vendors",
];

const PILLARS = [
    {
        title: "Modular suite",
        body: "Start with one module — smart carts, queue management or RFID inventory — and scale to the full stack when ready.",
    },
    {
        title: "Unified data fabric",
        body: "Every camera, cart, kiosk and shelf label feeds a single real-time event stream. One store, one schema.",
    },
    {
        title: "Open APIs",
        body: "Documented webhooks and REST endpoints into your POS, ERP, loyalty and ad-tech stack. No lock-in.",
    },
    {
        title: "Privacy by design",
        body: "On-device inference, anonymous shopper journeys and explicit consent at every touchpoint.",
    },
    {
        title: "Cloud + edge",
        body: "Heavy inference runs on-device; analytics and orchestration run on a managed multi-region cloud.",
    },
    {
        title: "Retail media native",
        body: "Every screen — cart, kiosk, ESL, DOOH — is a sellable, measurable advertising surface.",
    },
];

export default function StatsBand() {
    return (
        <section
            data-testid="stats-band"
            className="relative border-y border-white/10 bg-rt-bg"
        >
            {/* Marquee */}
            <div className="overflow-hidden border-b border-white/5 py-6">
                <div className="rt-marquee-track flex gap-14 whitespace-nowrap will-change-transform">
                    {[...PARTNERS, ...PARTNERS].map((p, i) => (
                        <span
                            key={i}
                            className="font-heading text-2xl tracking-tight text-white/30 hover:text-white/70 transition-colors"
                        >
                            {p}
                        </span>
                    ))}
                </div>
            </div>

            {/* Capability grid */}
            <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-20 lg:py-28">
                <div className="flex items-end justify-between flex-wrap gap-4 mb-14">
                    <div>
                        <div className="rt-eyebrow mb-3">Platform / Foundations</div>
                        <h2 className="rt-h2 text-3xl md:text-5xl text-white max-w-3xl">
                            One platform. <span className="text-white/40">Every system in the store talking.</span>
                        </h2>
                    </div>
                    <p className="max-w-md text-rt-text2 text-base">
                        ReTechler is built on six foundations that make every module
                        composable, observable and integrable from day one.
                    </p>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-3 border-t border-white/10">
                    {PILLARS.map((p, i) => (
                        <div
                            key={i}
                            data-testid={`pillar-${i}`}
                            className={`p-8 lg:p-10 border-b border-white/10 ${
                                (i + 1) % 3 !== 0 ? "md:border-r border-white/10" : ""
                            }`}
                        >
                            <div className="rt-mono-label mb-3">0{i + 1}</div>
                            <div className="font-heading text-xl lg:text-2xl text-white tracking-tight">
                                {p.title}
                            </div>
                            <div className="mt-3 text-sm text-rt-text2 max-w-[20rem] leading-relaxed">
                                {p.body}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
